<template lang="pug">
div
  v-card.elevation-0(v-if='state === "login"')
    v-toolbar.elevation-0(color='white')
      v-toolbar-title Aanmelden

    .pa-2
      v-card-text.pb-0
        v-form
          text-field.mr-0(
            name='email',
            label='Email',
            type='text',
            autofocus,
            v-model.trim='email',
            @keyup.enter='login'
            :error-messages='emailValidationErrors',
            @change='$v.email.$touch()',
            @blur='$v.email.$touch()'
            )
          text-field#password(
            name='password',
            label='Wachtwoord',
            type='password',
            v-model='password',
            @keyup.enter='login',
            :error-messages='passwordValidationErrors',
            @change='$v.password.$touch()',
            @blur='$v.password.$touch()',
            :append-icon="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
            @click:append='passwordVisible = !passwordVisible',
            :type="passwordVisible ? 'text' : 'password'"
            )

      v-card-actions
        v-btn(block, color='primary', @click='login', :loading='loading', :disabled='$v.$invalid') Login

      v-card-actions
        v-layout(justify-center)
          v-btn(flat, small, color='primary', @click='state = "forgotPassword"') Wachtwoord vergeten?

  v-card.elevation-0(v-else-if='state === "notVerified"')
    v-toolbar
      v-toolbar-title Account nog niet geactiveerd

    v-card-text
      p Je account is nog niet geactiveerd. Klik op de onderstaande knop om een nieuwe activatie mail te versturen.
      p Volg de instructies in de email.
    v-card-actions.pa-4
      v-spacer
      v-btn(color='primary', @click='resendVerificationMail', :loading='loading') Opnieuw versturen

  v-card.elevation-0(v-else-if='state === "forgotPassword"')
    v-toolbar.elevation-0(color='white')
      v-toolbar-title Wachtwoord vergeten?

    v-card-text
      p Wachtwoord kwijt? Vul je email adres in en drop op de knop om een email te ontvangen om je wachtwoord opnieuw in te stellen.
      v-text-field.mt-5(
        prepend-icon='fa fa-user',
        label='Email',
        type='text',
        autofocus,
        solo,
        v-model.trim='email',
        @keyup.enter='sendForgotPasswordMail',
        :error-messages='emailValidationErrors',
        @change='$v.email.$touch()',
        @blur='$v.email.$touch()'
        )
    v-card-actions.pa-4
      v-btn(flat, small, @click='state = "login"') Terug
      v-spacer
      v-btn(color='primary', @click='sendForgotPasswordMail', :loading='loading', :disabled='$v.email.$invalid') Nieuw wachtwoord
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Login',

  data () {
    return {
      email: null,
      password: null,
      loading: false,
      state: 'login',

      passwordVisible: false
    }
  },

  computed: {
    emailValidationErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push('Voer je email adres in')
      !this.$v.email.email && errors.push('Dit is geen geldig email adres')
      return errors
    },

    passwordValidationErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Voer je wachtwoord in')
      return errors
    }
  },

  methods: {
    async login () {
      this.loading = true

      try {
        const user = await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password
        })

        if (!user.organizations || user.organizations.length === 0) {
          this.$root.$snackbar.show('Je bent nog niet aan een organisatie gekoppeld. Neem contact op met de support afdeling.')

          this.$store.commit('auth/logout')

          this.loading = false
          return
        }

        this.$router.push({
          name: 'home'
        })
        window.location = '/'
      } catch (error) {
        console.error(error)

        if (error.response.status === 412) {
          this.state = 'notVerified'
        } else if (error.response.status === 403) {
          this.$root.$snackbar.show(`Je wachtwoord of gebruikersnaam is ongeldig. Probeer het nog een keer.`)
        } else if (error.response.status === 401) {
          this.$root.$snackbar.show(`Je account is niet actief. Neem contact met ons op om dit te verhelpen.`)
        }

        this.password = null
        this.$v.password.$reset()
      }

      this.loading = false
    },

    async resendVerificationMail () {
      this.loading = true

      try {
        await this.$store.dispatch('auth/resendVerification', {
          email: this.email
        })

        this.$router.push({
          name: 'login'
        })
      } catch (error) {
        console.error(error)

        this.$root.$snackbar.show('Er is iets fout gegaan. Probeer het nog een keer.')
      }

      this.loading = false
    },

    async sendForgotPasswordMail () {
      this.loading = true

      try {
        await this.$store.dispatch('auth/forgot', {
          email: this.email
        })
      } catch (error) {
        console.error(error)
      }

      this.state = 'login'

      this.$root.$snackbar.show('Indien dit email bekend is bij ons wordt er een mail verzonden met instructies.')

      this.loading = false
    }
  },

  validations: {
    email: {
      email,
      required
    },

    password: {
      required
    }
  },

  watch: {
    state () {
      this.$v.$reset()
    }
  }
}
</script>

<style lang="scss">
</style>
